/**
 * Aggregated revenues action types
 */

export const REVENUES_AGGREGATED_FAILED = '[REVENUES AGGREGATED] FAILED';
export const REVENUES_AGGREGATED_REQUESTED = '[REVENUES AGGREGATED] REQUESTED';
export const REVENUES_AGGREGATED_SUCCEEDED = '[REVENUES AGGREGATED] SUCCEEDED';
